import { defineStore } from "pinia"
import { UserDataTplClass,PubDataTplClass, UserDataTypeClass,DeviceClass, FirmwareClass, OtherMqttTopicClass, DeviceControlClass } from "@/apis"
import { UserDataTplDto, SearchUserDataTplArgs, SearchPubDataTplArgs, pubDataTplDto, SearchUserDataTypeArgs, UserDataTypeDto, SearchDeviceArgs, DeviceDto, SearchDeviceStateArgs, DeviceStateDto, SearchHGRealtimeDataArgs, HGRealtimeDataDto, DeviceInfoDto, IOBatchControlArgs, BatchDataDownArgs, BatchAddUserDataTypeArgs } from "@/models/device"
import { CreateOtherMqttTopicArgs, DataDownArgs, FirmwareDto, IndustryCascaderDto, OtherMqttTopicDto, QueryFirmawreArgs, QueryUpdateRecordArgs, ResponseDataType, UpdateRecordDto } from "@/models/types"

const userDataTpl = new UserDataTplClass()
const pubDataTpl = new PubDataTplClass()
const userDataType = new UserDataTypeClass()
const device = new DeviceClass()
const firmware = new FirmwareClass()
const mqttConfig = new OtherMqttTopicClass()
const deviceControlApi = new DeviceControlClass()
export const useDataStore = defineStore('data',{
  state: () => {
    return {
      userDataTplTotal: 0,
      pubDataTplTotal: 0,
      userDataTypeTotal: 0,
      deviceTotal: 0,
      deviceStateTotal: 0,
      historyDataTotal: 0,
      firmwareTotal: 0,
      updateRecordTotal: 0,

      industrys: <IndustryCascaderDto[]>[],
      
      pubDataTplList: <pubDataTplDto[]>[],
      userDataTplList: <UserDataTplDto[]>[],
      firmwareList: <FirmwareDto[]>[]
    }
  },
  getters: {},
  actions: {
    /**
     * 查询公共设备模板
     * @param params 
     * @returns 
     */
    getPubDataTpl(params: SearchPubDataTplArgs){
      return new Promise<pubDataTplDto[]>((resolve, reject) => {
        pubDataTpl.gets(params).then((resp: ResponseDataType<pubDataTplDto>) => {
          this.pubDataTplTotal = resp.total

          this.pubDataTplList = resp.data
          resolve(resp.data)
        }).catch(e => {
          reject(e)
        })
      })
    },
    /**
     * 查询用户设备模板
     * @param params SearchUserDataTplArgs
     * @returns UserDataTplDto[]
     */
    getUserDataTpl(params: SearchUserDataTplArgs){
      return new Promise<UserDataTplDto[]>((resolve, reject) => {
        userDataTpl.gets(params).then((resp: ResponseDataType<UserDataTplDto>) => {
          this.userDataTplTotal = resp.total
          this.userDataTplList = resp.data
          resolve(resp.data)
        }).catch(e => {
          reject(e)
        })
      })
    },

    /**
     * 添加用户设备模板
     * @param data UserDataTplDto
     * @returns number
     */
    createUserDataTpl(data: UserDataTplDto){
      return new Promise<number>((resolve, reject) => {
        userDataTpl.create(data).then((resp: number) => {
          resolve(resp)
        }).catch(e => {
          reject(e)
        })
      })
    },

    /**
     * 编辑用户设备模板
     * @param data UserDataTplDto
     * @returns number
     */
    editUserDataTpl(data: UserDataTplDto){
      return new Promise<number>((resolve, reject) => {
        userDataTpl.update(data).then((resp: number) => {
          resolve(resp)
        }).catch(e => {
          reject(e)
        })
      })
    },

    /**
     * 删除用户设备模板
     * @param id number
     * @returns number
     */
    deleteUserDataTpl(id: number){
      return new Promise<number>((resolve, reject) => {
        userDataTpl.remove(id).then((resp: number) => {
          resolve(resp)
        }).catch(e => {
          reject(e)
        })
      })
    },

    /**
     * 用户设备模板详情
     * @param id number
     * @returns UserDataTplDto
     */
    detailUserDataTpl(id: number){
      return new Promise<UserDataTplDto>((resolve, reject) => {
        userDataTpl.detail(id).then((resp: UserDataTplDto) => {
          resolve(resp)
        }).catch(e => {
          reject(e)
        })
      })
    },

    resetUserDataTpl(id: number){
      return new Promise<number>((resolve, reject) => {
        userDataTpl.resetUserDataTpl(id).then((resp: number) => {
          resolve(resp)
        }).catch(e => {
          reject(e)
        })
      })
    },

    /**
     * 获取用户设备模板数据类型
     * @param params 
     * @returns 
     */
    getUserDataType(params: SearchUserDataTypeArgs){
      return new Promise<UserDataTypeDto[]>((resolve, reject) => {
        userDataType.gets(params).then((resp: ResponseDataType<UserDataTypeDto>) => {
          this.userDataTypeTotal = resp.total
          resolve(resp.data)
        }).catch(e => {
          reject(e)
        })
      })
    },

    /**
     * 添加用户设备模板数据类型
     * @param data 
     * @returns 
     */
    createUserDataType(data: UserDataTypeDto){
      return new Promise<number>((resolve, reject) => {
        userDataType.create(data).then((resp: number) => {
          resolve(resp)
        }).catch(e => {
          reject(e)
        })
      })
    },

    /**
     * 编辑用户设备模板数据类型
     * @param data 
     * @returns 
     */
    editUserDataType(data: UserDataTypeDto){
      return new Promise<number>((resolve, reject) => {
        userDataType.update(data).then((resp: number) => {
          resolve(resp)
        }).catch(e => {
          reject(e)
        })
      })
    },

    /**
     * 删除用户设备模板数据类型
     * @param id 
     * @returns 
     */
    deleteUserDataType(id: number){
      return new Promise<number>((resolve, reject) => {
        userDataType.remove(id).then((resp: number) => {
          resolve(resp)
        }).catch(e => {
          reject(e)
        })
      })
    },

    batchAddUserDataType(tplid: number, list: BatchAddUserDataTypeArgs[]){
      return new Promise<number>((resolve, reject) => {
        userDataType.batchAdd(tplid, list).then(resp => {
          resolve(resp)
        }).catch(e => {
          reject(e)
        })
      })
    },

    /**
     * 查询设备列表
     * @param params 
     * @returns 
     */
    getDevice(params: SearchDeviceArgs){
      return new Promise<DeviceDto[]>((resolve, reject) => {
        device.gets(params).then((resp: ResponseDataType<DeviceDto>) => {
          this.deviceTotal = resp.total
          resolve(resp.data)
        }).catch(e => {
          reject(e)
        })
      })
    },

    /**
     * 查询设备详情通过sn
     * @param sn 
     * @returns 
     */
    getDeviceDetail(sn: string){
      return new Promise<DeviceDto>((resolve, reject) => {
        device.detailBySN(sn).then((resp: DeviceDto) => {
          resolve(resp)
        }).catch(e => {
          reject(e)
        })
      })
    },

    /**
     * 查询用户设备
     * @param params 
     * @returns 
     */
    getUserDevice(params: SearchDeviceArgs){
      return new Promise<DeviceDto[]>((resolve, reject) => {
        device.userGets(params).then((resp: ResponseDataType<DeviceDto>) => {
          this.deviceTotal = resp.total
          resolve(resp.data)
        }).catch(e => {
          reject(e)
        })
      })
    },

    /**
     * 查询设备状态统计信息
     * @returns 
     */
    getUserDeviceInfo(){
      return new Promise<DeviceInfoDto>((resolve, reject) => {
        device.deviceInfo().then((resp: DeviceInfoDto) => {
          resolve(resp)
        }).catch(e => {
          reject(e)
        })
      })
    },

    /**
     * 查询设备上下线记录
     * @param params 
     * @returns 
     */
    getDeviceState(params: SearchDeviceStateArgs){
      return new Promise<DeviceStateDto[]>((resolve, reject) => {
        device.getStates(params).then((resp: ResponseDataType<DeviceStateDto>) => {
          this.deviceStateTotal = resp.total
          resolve(resp.data)
        }).catch(e => {
          reject(e)
        })
      })
    },

    /**
     * 查询设备历史数据
     * @param params SearchHGRealtimeDataArgs
     * @returns 
     */
    getHistory(params: SearchHGRealtimeDataArgs){
      return new Promise<HGRealtimeDataDto[]>((resolve, reject) => {
        device.getHistory(params).then((resp: ResponseDataType<HGRealtimeDataDto>) => {
          this.historyDataTotal = resp.total
          resolve(resp.data)
        }).catch(e => {
          reject(e)
        })
      })
    },

    getHistorySimple(params: SearchHGRealtimeDataArgs){
      return new Promise<any[]>((resolve, reject) => {
        device.getHistorySimple(params).then((resp: ResponseDataType<any>) => {
          this.historyDataTotal = resp.total
          resolve(resp.data)
        }).catch(e => {
          reject(e)
        })
      })
    },

    /**
     * 批量板载io控制
     * @param sn 
     * @param list 
     * @returns 
     */
    batchIOControl(sn: string, list: IOBatchControlArgs[]){
      return new Promise<number>((resolve, reject) => {
        deviceControlApi.io(sn, list).then((resp: number) => {
          resolve(resp)
        }).catch(e => {
          reject(e)
        })
      })
    },

    /**
     * 批量外接IO控制
     * @param sn 
     * @param list 
     * @returns 
     */
    batchIOuControl(sn: string, list: IOBatchControlArgs[]){
      return new Promise<number>((resolve, reject) => {
        deviceControlApi.iou(sn, list).then((resp: number) => {
          resolve(resp)
        }).catch(e => {
          reject(e)
        })
      })
    },

    /**
     * 批量数据下发
     * @param sn 
     * @param list 
     * @returns 
     */
    batchDataDown(sn: string, list: BatchDataDownArgs[]){
      return new Promise<number>((resolve, reject) => {
        deviceControlApi.down(sn, list).then((resp: number) => {
          resolve(resp)
        }).catch(e => {
          reject(e)
        })
      })
    },

    /**
     * 查询固件升级列表
     * @param params 
     * @returns 
     */
    getFirmwares(params: QueryFirmawreArgs){
      return new Promise<FirmwareDto[]>((resolve, reject) => {
        firmware.gets(params).then((resp: ResponseDataType<FirmwareDto>) => {
          this.firmwareTotal = resp.total
          this.firmwareList = resp.data
          resolve(resp.data)
        }).catch(e => {
          reject(e)
        })
      })
    },

    /**
     * 添加固件升级
     * @param data 
     * @returns 
     */
    createFirmware(data: any){
      return new Promise<number>((resolve, reject) => {
        firmware.add(data).then((resp: number) => {
          resolve(resp)
        }).catch(e => {
          reject(e)
        })
      })
    },

    /**
     * 查询固件升级记录
     * @param params 
     * @returns 
     */
    getUpdateLogs(params: QueryUpdateRecordArgs){
      return new Promise<UpdateRecordDto[]>((resolve, reject) => {
        firmware.getUpdateLogs(params).then(resp => {
          this.updateRecordTotal = resp.total
          resolve(resp.data)
        }).catch(e => {
          reject(e)
        })
      })
    },

    changefirmwareIsActive(id: number, state: boolean){
      return new Promise<number>((resolve, reject) => {
        firmware.state(id, state).then((resp: number) => {
          resolve(resp)
        }).catch(e => {
          reject(e)
        })
      })
    },

    deleteFirmware(id: number){
      return new Promise<number>((resolve, reject) => {
        firmware.remove(id).then((resp: number) => {
          resolve(resp)
        }).catch(e => {
          reject(e)
        })
      })
    },

    downloadFirmware(tplid: number, versionfile: string){
      return new Promise<ArrayBuffer>((resolve, reject) => {
        firmware.download(tplid, versionfile).then((resp) => {
          resolve(resp)
        }).catch(e => {
          reject(e)
        })
      })
    },

    getNewFirmwareVersions(key: string){
      return new Promise<FirmwareDto[]>((resolve, reject) => {
        firmware.getLastByKey(key).then((resp: FirmwareDto[]) => {
          resolve(resp)
        }).catch(e => {
          reject(e)
        })
      })
    },

    onGetIndustrys(){
      return new Promise((resolve, reject) => {
        device.getIndustryOptions().then((resp) => {

          this.industrys = resp.map(x => {
            if(x.children.length > 0){
              x.disabled = false
            }else{
              x.disabled = true
            }
            return x
          })
          
          resolve(1)
        }).catch(e => {
          reject(e)
        })
      })
    },

    IOControl(SN: string, IO: number, Value: number){
      return new Promise((resolve, reject) => {
        device.IOControl(SN, IO, Value).then(() => {          
          resolve(1)
        }).catch(e => {
          reject(e)
        })
      })
    },
    
    dataDown(sn: string, list: DataDownArgs[]){
      return new Promise((resolve, reject) => {
        device.dataDown(sn, list).then(() => {          
          resolve(1)
        }).catch(e => {
          reject(e)
        })
      })
    },

    changeUpdateMode(id: string, mode: number){
      return new Promise<number>((resolve, reject) => {
        device.changeUpdateMode(id, mode).then((resp) => {          
          resolve(resp)
        }).catch(e => {
          reject(e)
        })
      })
    },

    reboot(SN: string){
      return new Promise((resolve, reject) => {
        device.reboot(SN).then(() => {          
          resolve(1)
        }).catch(e => {
          reject(e)
        })
      })
    },

    rename(id: string, title: string){
      return new Promise((resolve, reject) => {
        device.rename(id, title).then(resp => {          
          resolve(resp)
        }).catch(e => {
          reject(e)
        })
      })
    },

    deleteDevice(id: string){
      return new Promise((resolve, reject) => {
        device.del(id).then(() => {          
          resolve(1)
        }).catch(e => {
          reject(e)
        })
      })
    },

    changeHost(SN: string){
      return new Promise((resolve, reject) => {
        device.changeHost(SN).then(() => {          
          resolve(1)
        }).catch(e => {
          reject(e)
        })
      })
    },

    /**
     * 查询模板mqtt配置信息
     * @param tplId 
     * @returns 
     */
    getOtherMqttTopic(tplId: number){
      return new Promise<OtherMqttTopicDto>((resolve, reject) => {
        mqttConfig.detail(tplId).then((resp) => {
          resolve(resp)
        }).catch(e => {
          reject(e)
        })
      })
    },

    /**
     * 添加模板mqtt配置信息
     * @param data CreateOtherMqttTopicArgs
     * @returns number
     */
    createOtherMqttTopic(data: CreateOtherMqttTopicArgs){
      return new Promise<number>((resolve, reject) => {
        mqttConfig.create(data).then((resp: number) => {
          resolve(resp)
        }).catch(e => {
          reject(e)
        })
      })
    },

    /**
     * 编辑模板mqtt配置信息
     * @param data CreateOtherMqttTopicArgs
     * @returns number
     */
    editOtherMqttTopic(data: CreateOtherMqttTopicArgs){
      return new Promise<number>((resolve, reject) => {
        mqttConfig.update(data).then((resp: number) => {
          resolve(resp)
        }).catch(e => {
          reject(e)
        })
      })
    },
  }
})